import Api from '@/data/Api.ts';

const URL_NOTIFICATIONS = 'notifications';

export default class NotificationsApi extends Api {
  get(): Promise<any> {
    return this.standardGet(URL_NOTIFICATIONS, {}).then((rsp) =>
      this.extractArray(rsp),
    );
  }
}
